export default "__VITE_ASSET__04230984__"